import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

export default function CustomDataModal({
  isOpen,
  children,
  header,
  onClose,
  size,
  top = false,
  light = false,
  flush = false,
}) {
  return (
    <Modal
      blockScrollOnMount={false}
      scrollBehavior="inside"
      isCentered={!top}
      size={size ? size : "4xl"}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent maxH={"90vh"} mt={top ? "20px" : undefined}>
        <ModalHeader color={light ? "#222" : "white"} bg={light ? "white" : "#2B2B2B"}>
          {header}
        </ModalHeader>
        <ModalCloseButton onClick={onClose} color={light ? "white" : "white"} bg={light ? "black" : undefined} borderRadius={light ? "full" : undefined} />
        <ModalBody p={flush ? 0 : undefined}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
